import { marker } from '@colsen1991/ngx-translate-extract-marker';

export enum ChargeTypeEnum {
    SHIPPING = 'SHIPPING',
    HANDLING = 'HANDLING',
    PACKAGING = 'PACKAGING',
    INSURANCE = 'INSURANCE',
    EXPRESS_DELIVERY = 'EXPRESS_DELIVERY',
    FUEL_SURCHARGE = 'FUEL_SURCHARGE',
}

export interface IChargeTypeOption {
    readonly value: ChargeTypeEnum;
    readonly label: string;
}

export const CHARGE_TYPE_LABELS: Readonly<Record<string, string>> = {
    [ChargeTypeEnum.SHIPPING]: marker('Versand'),
    [ChargeTypeEnum.HANDLING]: marker('Bearbeitung'),
    [ChargeTypeEnum.PACKAGING]: marker('Verpackung'),
    [ChargeTypeEnum.INSURANCE]: marker('Versicherung'),
    [ChargeTypeEnum.EXPRESS_DELIVERY]: marker('Expresslieferung'),
    [ChargeTypeEnum.FUEL_SURCHARGE]: marker('Treibstoffzuschlag'),
};

export const CHARGE_TYPE_OPTIONS: ReadonlyArray<IChargeTypeOption> = Object.values(ChargeTypeEnum).map((value) => ({
    value,
    label: CHARGE_TYPE_LABELS[value],
}));
